import { Component, computed, effect, inject, signal } from '@angular/core';
import { BuildingMapDto, InspectionItemDto, InspectionService, LastInspectionFilterDto } from '@artemis-software/wr-api';
import { firstValueFrom } from 'rxjs';
import { tryWithLoadingSignal } from '@/utils/async-utils';
import { loader } from '@/utils/signals/loader';
import { currentTenantId } from '@/utils/admin-utils';

@Component({
  standalone: false,
  templateUrl: './map-overview-popup-panel.component.html',
  styleUrls: ['./map-overview-popup-panel.component.scss'],
})
export class MapOverviewPopupPanelComponent {

  private readonly inspectionService = inject(InspectionService);

  readonly building = signal<BuildingMapDto | undefined>(undefined);
  readonly tenantId = currentTenantId();
  readonly lastInspection = signal<InspectionItemDto | undefined>(undefined);
  readonly loading = loader();

  readonly buildingIdentifier = computed(() => {
    const b = this.building();
    const name = b?.name?.length ? b.name : 'Gebäude';
    return `${name} (${b?.internalNumber})`;
  });

  constructor() {
    effect(() => {
      const b = this.building();
      if (b) {
        this.getLastInspection();
      }
    });
  }

  private async getLastInspection() {
    await tryWithLoadingSignal(this.loading, async () => {
      const tenantId = this.tenantId();
      if (!tenantId) {
        return;
      }
      const lastInspections = await firstValueFrom(this.inspectionService.findLastInspectionByBuilding({
        buildingId: this.building()?.id,
        tenantId: tenantId,
        inspectionType: LastInspectionFilterDto.InspectionTypeEnum.Regular,
      }));
      if (!lastInspections.length) {
        this.lastInspection.set(undefined);
      } else {
        this.lastInspection.set(lastInspections[0]);
      }
    });
  }
}
